import { Component, Input } from '@angular/core';
import { Comprobante } from "@shared/models/facturacion/Comprobante";
import { VisorImpuestoComponent } from "@shared/visor-impuesto/visor-impuesto.component";
import { ComprobanteService } from "@facturacion/comprobante.service";
import { NotificacionesService } from "@abm/notificacion/notificaciones.service";
import { MessageService } from "@shell/message.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { VisorCuponComponent } from "@shared/visor-cupon/visor-cupon.component";
import { saveAs } from 'file-saver';
import { NotificacionesComprobantes } from "@shared/models/notificaciones";
import { ErrorModel } from "@shared/models/ErrorModel";
import { Renglon } from "@shared/models/facturacion/Renglon";
import { ImpuestoPercepcion } from "@shared/models/facturacion/ImpuestoPercepcion";

@Component({
  selector: 'app-panel-botones-comprobantes',
  templateUrl: './panel-botones-comprobantes.component.html',
  styles: `#botones
  {
  box-sizing:border-box;
  max-height: calc(110vh - 18rem);
  overflow-y: auto;
  }`
})

export class PanelBotonesComprobantesComponent {
  @Input() documentoObtenido: Comprobante;
  
  descargando: boolean = false;
  reenviando: boolean = false;
  mensajeError: string;

  constructor ( private comprobanteService: ComprobanteService,
                private spinner: NgxSpinnerService,
                private notificacionesService: NotificacionesService,
                private messageService: MessageService,
                public activeModal: NgbModal ) { }

  exportarRemito(f:Comprobante) {
    this.spinner.show('spinnerExportar');
    this.comprobanteService.exportarRemitosDeFactura(f.prefijo,f.numeroComprobante,f.tipoMovimiento)
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        saveAs(blob, "factura" + f.prefijo + "-" + f.numeroComprobante + ".xlsx");
        this.spinner.hide('spinnerExportar');
      }, ()=> {
        this.spinner.hide('spinnerExportar');
      });
  }

  verImpuestos() {
    const renglones: Renglon[] = [];
    const impuestos: ImpuestoPercepcion[] = [];
    this.documentoObtenido.factura.renglones.forEach((value, index) => {
      renglones.push(this.documentoObtenido.factura.renglones[index]);
      this.documentoObtenido.factura.renglones[index].impuestosPercepciones.forEach((value2, index2) => {
        impuestos.push(this.documentoObtenido.factura.renglones[index].impuestosPercepciones[index2]);
      });
    });
    const modalRef = this.activeModal.open(VisorImpuestoComponent, { size: 'lg', centered: true, backdrop: 'static' })
    modalRef.componentInstance.renglones = renglones;
  }

  verCupones() {
    const modalRef = this.activeModal.open(VisorCuponComponent, { size: 'lg', centered: true, backdrop: 'static' })
    modalRef.componentInstance.cupones = this.documentoObtenido.factura.pago[0].cupones;
  }

  descargarComprobante(f:Comprobante) {
    this.descargando = true;
    this.comprobanteService.descargarFactura(f)
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        saveAs(blob, f.prefijo + '-' + f.numeroComprobante + ' ' + f.fechaHoraCreacion + '.pdf');
        this.descargando = false;
      }, () => {
        this.descargando = false;
      });
  }

  reenviarCorreo() {
    let email: any;
    this.mensajeError = null;
    this.reenviando = true;
    const comprobanteNotificaciones = new NotificacionesComprobantes();
    comprobanteNotificaciones.facturaId = this.documentoObtenido.id;
    comprobanteNotificaciones.numeroDocumento = this.documentoObtenido.cliente.numeroDocumento;
    comprobanteNotificaciones.codigoAeroplanta = this.documentoObtenido.codigoAeroplanta;
    comprobanteNotificaciones.tipoMovimiento = this.documentoObtenido.tipoMovimiento;
    comprobanteNotificaciones.prefijo = this.documentoObtenido.prefijo;
    comprobanteNotificaciones.numero = this.documentoObtenido.numeroComprobante;
    this.notificacionesService.enviarFactura(comprobanteNotificaciones)
      .subscribe((result) => {
        email = result;
        this.messageService.showSuccessLongMessage('El comprobante se reenvío a los correos: ' + email.item1);
        this.reenviando = false;
      }, (err: ErrorModel) => {
        this.messageService.showErrorLongMessage(err.description);
        this.reenviando = false;
      });
  }

  get showCupones() {
    return this.documentoObtenido.factura?.pago[0]?.cupones?.filter(c=>c.pathCuponFisico!='').length>0;
  }
}
  
